// Pure (no-React) helpers for mapping lender records to/from the Terms form.
// Extracted from floorplan.tsx so the mapping can be unit-tested in isolation,
// guarding against a future schema/UI change silently dropping fields such as
// the Westlake curtailment percentages (curtailmentPct1-3).

export interface TermsFormState {
  name: string;
  period1Days: string; period2Days: string; period3Days: string; period4Days: string;
  aprRate: string;
  feePeriod1: string; feePeriod2: string; feePeriod3: string; feePeriod4: string;
  curtailment1Type: "percent" | "dollar"; curtailment1Value: string;
  curtailment2Type: "percent" | "dollar"; curtailment2Value: string;
  curtailmentPct1: string; curtailmentPct2: string; curtailmentPct3: string;
  avgUnitsPerMonth: string;
  pricingType: "tiered" | "fixed" | null; // null = standard period-based fees
  fixedFeePerUnit: string;
  aiNotes: string; // display-only notes from AI lender lookup (not persisted to DB)
}

export function emptyTermsForm(name = ""): TermsFormState {
  return {
    name,
    period1Days: "60", period2Days: "30", period3Days: "30", period4Days: "",
    aprRate: "",
    feePeriod1: "", feePeriod2: "", feePeriod3: "", feePeriod4: "",
    curtailment1Type: "percent", curtailment1Value: "",
    curtailment2Type: "percent", curtailment2Value: "",
    curtailmentPct1: "", curtailmentPct2: "", curtailmentPct3: "",
    avgUnitsPerMonth: "10",
    pricingType: "fixed",
    fixedFeePerUnit: "",
    aiNotes: "",
  };
}

export function lenderToTermsForm(lender: any): TermsFormState {
  const hasTiers = Array.isArray(lender.tiers) && lender.tiers.length > 0;
  return {
    name: lender.name,
    period1Days: lender.period1Days != null ? String(lender.period1Days) : "60",
    period2Days: lender.period2Days != null ? String(lender.period2Days) : "30",
    period3Days: lender.period3Days != null ? String(lender.period3Days) : "30",
    period4Days: lender.period4Days != null ? String(lender.period4Days) : "",
    aprRate: lender.aprRate != null ? String(lender.aprRate) : "",
    feePeriod1: lender.feePeriod1 != null ? String(lender.feePeriod1) : "",
    feePeriod2: lender.feePeriod2 != null ? String(lender.feePeriod2) : "",
    feePeriod3: lender.feePeriod3 != null ? String(lender.feePeriod3) : "",
    feePeriod4: lender.feePeriod4 != null ? String(lender.feePeriod4) : "",
    curtailment1Type: (lender.curtailment1Type as "percent" | "dollar") ?? "percent",
    curtailment1Value: lender.curtailment1Value != null ? String(lender.curtailment1Value) : "",
    curtailment2Type: (lender.curtailment2Type as "percent" | "dollar") ?? "percent",
    curtailment2Value: lender.curtailment2Value != null ? String(lender.curtailment2Value) : "",
    curtailmentPct1: lender.curtailmentPct1 != null ? String(lender.curtailmentPct1) : "",
    curtailmentPct2: lender.curtailmentPct2 != null ? String(lender.curtailmentPct2) : "",
    curtailmentPct3: lender.curtailmentPct3 != null ? String(lender.curtailmentPct3) : "",
    avgUnitsPerMonth: lender.avgUnitsPerMonth != null ? String(lender.avgUnitsPerMonth) : "10",
    pricingType: hasTiers ? "tiered" : (lender.pricingType ?? "fixed"),
    fixedFeePerUnit: lender.fixedFeePerUnit != null ? String(lender.fixedFeePerUnit) : "",
    aiNotes: "",
  };
}
